import React, { useState, useEffect } from 'react';

const ImageRotator = ({ images, interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        images.forEach(src => {
            const img = new Image();
            img.src = src;
        });
    }, [images]);

    useEffect(() => {
        console.log('images', images);

        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, interval);

        return () => clearInterval(timer);
    }, [images.length, interval]);

    return (
        <div className="image-container">
            <img
                src={images[currentIndex]}
                alt="samurai image"
                className="samurai-image"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
                draggable={false}
                style={{ userSelect: 'none', pointerEvents: 'none' }}
            />
        </div>
    );
};

export default ImageRotator;
